import { addAssignment as addAssignmentAPI } from "../api";
import dayjs from "dayjs";

export const addAssignmentAction = async (classID, assignmentID, setClass) => {
  const classObject = await addAssignmentAPI(classID, assignmentID, dayjs());
  setClass(classObject.data)
};
